module.exports = __webpack_public_path__ + "files/225d0635a20416a91a220c039903cf62.png";